import { render } from "./EditConfigDialog.vue?vue&type=template&id=35cc8baa&scoped=true"
import script from "./EditConfigDialog.vue?vue&type=script&lang=js"
export * from "./EditConfigDialog.vue?vue&type=script&lang=js"

import "./EditConfigDialog.vue?vue&type=style&index=0&id=35cc8baa&scoped=true&lang=scss"

import exportComponent from "/data/soft/jenkins/jobs/release-ms-front/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cc8baa"]])

export default __exports__